import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=7c04b47c&scoped=true"
import script from "./HistoryComponent.vue?vue&type=script&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoryComponent.vue?vue&type=style&index=0&id=7c04b47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c04b47c",
  null
  
)

export default component.exports